import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import CookieBanner from '../components/CookieBanner';
import MagazineBanner from '../components/MagazineBanner';
import HomePopup from '../components/HomePopup';

function Layout() {

  return (
    <div className="min-vh-100 d-flex flex-column font-family-sans-serif bg-white text-dark">
      <Header />

      {/* Content area */}
      <div className="flex-grow-1" style={{ paddingTop: "80px" }}>
        <Outlet />
      </div>

      <CookieBanner />
      <MagazineBanner />
      <HomePopup />

      <Footer />
    </div>
  );
}

export default Layout;